// Editorial menu data. Only "featured" items render a clipped photo frame.
export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1762657425062-3817aaf24312?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxkYXJrJTIwbW9vZHklMjBzcGVjaWFsdHklMjBjb2ZmZWV8ZW58MHx8fHwxNzg1OTU0MDEyfDA&ixlib=rb-4.1.0&q=85",
  espresso: "https://images.unsplash.com/photo-1764813824081-57e95825dc89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxkYXJrJTIwbW9vZHklMjBzcGVjaWFsdHklMjBjb2ZmZWV8ZW58MHx8fHwxNzg1OTU0MDEyfDA&ixlib=rb-4.1.0&q=85",
  cold: "https://images.unsplash.com/photo-1642647391072-6a2416f048e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxkYXJrJTIwbW9vZHklMjBpY2VkJTIwY29mZmVlfGVufDB8fHx8MTc4NTk1NDAxMnww&ixlib=rb-4.1.0&q=85",
  pastry: "https://images.unsplash.com/photo-1458253756247-1e4ed949191b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxkYXJrJTIwbW9vZHklMjBwYXN0cnl8ZW58MHx8fHwxNzg1OTU0MDEyfDA&ixlib=rb-4.1.0&q=85",
};

export const CATEGORIES = [
  {
    id: "espresso",
    number: "01",
    title: "Espresso",
    caption: "Pulled short, read slow.",
    hero: IMAGES.espresso,
    items: [
      { name: "Ristretto", origin: "Ethiopia · Guji", note: "Restricted extraction. 18g in, 22g out.", price: "4.50", featured: true },
      { name: "Espresso", origin: "Colombia · Huila", note: "Chocolate, molasses, black cherry.", price: "4.00" },
      { name: "Macchiato", origin: "House Blend", note: "Kissed with a spoon of foam.", price: "4.50" },
      { name: "Cortado", origin: "Kenya · Nyeri", note: "Bright, balanced, 1:1 milk.", price: "5.00" },
      { name: "Piccolo Latte", origin: "House Blend", note: "A whisper of steamed milk.", price: "5.50" },
    ],
  },
  {
    id: "coffee",
    number: "02",
    title: "Coffee",
    caption: "The long, quiet ritual.",
    hero: null,
    items: [
      { name: "Filter · V60", origin: "Rwanda · Nyamasheke", note: "Jasmine, bergamot, honey.", price: "6.50", featured: true },
      { name: "Chemex", origin: "Ethiopia · Yirgacheffe", note: "Peach, lemon peel, tea-like.", price: "7.00" },
      { name: "French Press", origin: "Sumatra · Aceh", note: "Cedar, dark cocoa, tobacco.", price: "5.50" },
      { name: "Flat White", origin: "House Blend", note: "Silky microfoam. Textbook craft.", price: "5.50" },
      { name: "Cappuccino", origin: "House Blend", note: "Equal thirds. Nothing wasted.", price: "5.50" },
      { name: "Cafe Latte", origin: "House Blend", note: "For the long conversations.", price: "5.75" },
    ],
  },
  {
    id: "tea",
    number: "03",
    title: "Tea",
    caption: "Leaves that remember rain.",
    hero: null,
    items: [
      { name: "Gyokuro", origin: "Uji, Japan", note: "Shade-grown. Umami, kelp, seagrass.", price: "8.00", featured: true },
      { name: "Silver Needle", origin: "Fujian, China", note: "Sun-dried buds. Melon, honeysuckle.", price: "9.00" },
      { name: "Dan Cong Oolong", origin: "Guangdong, China", note: "Orchid, orange blossom, roast.", price: "7.50" },
      { name: "Assam Second Flush", origin: "Assam, India", note: "Malt, stone fruit, dark honey.", price: "5.50" },
      { name: "Matcha Ceremonial", origin: "Kyoto, Japan", note: "Whisked by hand. Bright and vegetal.", price: "7.00" },
    ],
  },
  {
    id: "cold",
    number: "04",
    title: "Cold Drinks",
    caption: "Ice, glass, and a little patience.",
    hero: IMAGES.cold,
    items: [
      { name: "Cold Brew", origin: "18-hour steep", note: "Slow-drawn. Deep, low-acid.", price: "6.00", featured: true },
      { name: "Nitro Cold Brew", origin: "House Blend", note: "Cascading nitrogen. Cream head.", price: "7.00" },
      { name: "Iced Latte", origin: "House Blend", note: "Cold milk, hot shot, over ice.", price: "6.00" },
      { name: "Espresso Tonic", origin: "Kenya · Nyeri", note: "Bitter meets citrus. Effervescent.", price: "6.50" },
      { name: "Shakerato", origin: "Colombia · Huila", note: "Shaken over ice until crowned.", price: "6.50" },
    ],
  },
  {
    id: "pastries",
    number: "05",
    title: "Pastries",
    caption: "Made this morning. Not the last.",
    hero: IMAGES.pastry,
    items: [
      { name: "Dark Chocolate Torte", origin: "Baked in-house", note: "Single-origin cacao, sea salt.", price: "7.50", featured: true },
      { name: "Butter Croissant", origin: "72-hour laminate", note: "Cultured French butter. All flake.", price: "4.50" },
      { name: "Almond Cruffin", origin: "Baked in-house", note: "Frangipane, orange peel.", price: "5.00" },
      { name: "Sourdough Cardamom Bun", origin: "Baked in-house", note: "Wild yeast. Warmed to order.", price: "5.50" },
      { name: "Basque Cheesecake", origin: "Baked in-house", note: "Burnt top. Molten centre.", price: "6.50" },
    ],
  },
];
